import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import { useSelector } from "react-redux";
import { capitalize } from "@mui/material";
import { toast } from "react-toastify";
import { SendPostRequest } from "../../http";
import Captcha from "../Captcha/Captcha";
import { formatTime } from "../../Helper/Helper";
import { Table } from "react-bootstrap";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

function HospitalClinic() {
  const sitedata = useSelector((store) => store.global.loginData);
  const patientLogin = useSelector((state) => state.patient.patientLogin);
  const { slug } = useParams();
  const navigate = useNavigate();
  const [hospitalDetail, setHospitalDetail] = useState([]);
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [gender, setGender] = useState(null);
  const [shift, setShift] = useState(null);
  const [relation, setRelation] = useState(null);
  const [inputValues, setInputValues] = useState({});
  const [hospitalSlots, setHospitalSlots] = useState([]);
  const [displayedValue, setDisplayedValue] = useState(null);
  const [bookingDay, setBookingDay] = useState("");
  const todayDate = new Date().toISOString().split("T")[0];
  const [apiMessage, setApiMessage] = useState("");

  // get hospital slots

  useEffect(() => {
    const getHospitalSlots = async () => {
      const date = inputValues.appointment_date;
      const type = sitedata.site_type;
      let allInputs;

      try {
        allInputs = {
          type,
          doct_uid: sitedata.site_id,
          clinic_id: selectedHospital?.value?.info?.uid,
          date,
        };
        if (date) {
          const res = await SendPostRequest("hospitals/slots", allInputs);

          if (res.status === "fail") {
            setHospitalSlots(null); // No slot available
            setApiMessage(res.message || "No slots available"); // Store API message
          } else {
            setHospitalSlots(res.data);
            setApiMessage(""); // Clear message if success
          }
        }
      } catch (error) {
        console.error("Error fetching doctor's slots:", error);
        setApiMessage("Error fetching slots");
      }
    };
    getHospitalSlots();
  }, [inputValues.appointment_date, selectedHospital]);
  // useEffect(() => {
  //   const getHospitalSlots = async () => {
  //     const date = inputValues.appointment_date;
  //     const type = sitedata.site_type;
  //     let allInputs;

  //     try {
  //       allInputs = {
  //         type,
  //         doct_uid: sitedata.site_id,
  //         clinic_id: selectedHospital?.value?.info?.uid,
  //         date,
  //       };
  //       if (date) {
  //         const res = await SendPostRequest("hospitals/slots", allInputs);

  //         if (res.status === "fail") {
  //           setHospitalSlots(null); 
  //         } else {
  //           setHospitalSlots(res.data);
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error fetching doctor's slots:", error);
  //     }
  //   };
  //   getHospitalSlots();
  // }, [inputValues.appointment_date, selectedHospital]);

  const [shiftOptions, setShiftOptions] = useState([]);


  const formatDate = (inputDate) => {
    const dateObject = new Date(inputDate);
    const year = dateObject.getFullYear();
    const month = dateObject.getMonth() + 1;
    const day = dateObject.getDate();

    return `${year}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day
      }`;
  };

  const handleContactNumber = (e) => {
    let val = e.target.value;
    if (val.length <= 14) {
      setInputValues((prevValues) => ({
        ...prevValues,
        contact_number: val,
      }));
    }
  };

  const handleAllInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "appointment_date") {
      const formattedDate = formatDate(value);
      const selectedDate = new Date(formattedDate);
      const dayOfWeek = selectedDate.toLocaleDateString("en-US", {
        weekday: "long",
      });
      setBookingDay(dayOfWeek);

      setInputValues((prevValues) => ({
        ...prevValues,
        appointment_date: formattedDate,
      }));
    } else {
      setInputValues((prevValues) => ({
        ...prevValues,
        [name]: value,
      }));
    }
  };

  const [apointmentDays, setApointmentDays] = useState([]);

  const getDoctorsDetail = async () => {
    try {
      const response = await SendPostRequest("doctors/schedule");
      const hospitals = response?.data?.hospitals;

      if (hospitals && hospitals.length > 0) {
        setHospitalDetail(hospitals);
        const initialHospital = hospitals.find((h) => h.info.slug === slug) || hospitals[0];
        if (initialHospital) {
          setSelectedHospital({ label: initialHospital.info.title, value: initialHospital });
        }
      }
    } catch (error) {
      console.error("Error fetching doctor's schedule:", error);
    }
  };

  // Fetch hospital slots
  useEffect(() => {
    const getHospitalSlots = async () => {
      if (!inputValues.appointment_date || !selectedHospital) return;

      try {
        const payload = {
          type: sitedata.site_type,
          doct_uid: sitedata.site_id,
          clinic_id: selectedHospital.value.info.uid,
          date: inputValues.appointment_date,
        };

        const res = await SendPostRequest("hospitals/slots", payload);

        if (res.status === "fail") {
          setHospitalSlots(null);
          setApiMessage(res.message || "No slots available");
        } else {
          setHospitalSlots(res.data);
          setApiMessage("");
        }
      } catch (error) {
        console.error("Error fetching slots:", error);
        setApiMessage("Error fetching slots");
      }
    };

    getHospitalSlots();
  }, [inputValues.appointment_date, selectedHospital]);

  // Set shift options based on slots or fallback
  useEffect(() => {
    const newShiftOptions = [];

    if (hospitalSlots && Object.keys(hospitalSlots).length > 0) {
      for (const key in hospitalSlots) {
        newShiftOptions.push({ value: key, label: hospitalSlots[key] });
      }
    } else if (selectedHospital && inputValues.appointment_date) {
      newShiftOptions.push({ value: "morning", label: "Morning" });
      newShiftOptions.push({ value: "evening", label: "Evening" });
    }

    setShiftOptions(newShiftOptions);
    setDisplayedValue(null);
  }, [hospitalSlots, selectedHospital, inputValues.appointment_date]);

  const handleHospitalChange = (selectedOption) => {
    setSelectedHospital(selectedOption);
    if (selectedOption?.value?.info?.slug) {
      navigate(`/hospital-clinic/${selectedOption.value.info.slug}`);
    }
    setShift(null);
    setDisplayedValue(null);
  };
  //   const handleHospitalChange = (selectedOption) => {
  //   setSelectedHospital(selectedOption);
  //   if (selectedOption?.value?.info?.slug) {
  //     navigate(`/hospital-clinic/${selectedOption.value.info.slug}`);
  //   }
  // };


  useEffect(() => {
    if (patientLogin) {
      setInputValues({
        patient_name: patientLogin?.fullname,
        email: patientLogin?.email,
        contact_number: patientLogin?.contact_num,
      });
    }

    window.scrollTo(0, 0);
    getDoctorsDetail();
    handleRefresh();
  }, [slug]);



  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];

  const handleReasonChange = (selectedOption) => {
    setRelation(selectedOption.value);
  };

  const handleGenderChange = (selectedOption) => {
    setGender(selectedOption.value);
  };

  const handleShiftChange = (selectedOption) => {
    setShift(selectedOption.value);
    setDisplayedValue(selectedOption?.label);
  };

  const [captcha, setCaptcha] = useState("");
  const [input_captcha, setInputCaptcha] = useState("");
  const [check_captcha, setCheckCaptcha] = useState("");
  const [loading, setLoading] = useState(false);

  const textColorClass =
    check_captcha === "Captcha Verified" ? "text-success" : "text-danger";

  const handleInputChange = (e) => {
    setInputCaptcha(e.target.value);
  };

  const handleRefresh = () => {
    const newCaptcha = generateRandomCaptcha();
    setCaptcha(newCaptcha);
  };

  const reasonOptions = [
    { value: "son-of", label: "Son Of" },
    { value: "daughter-of", label: "Daughter Of" },
    { value: "father-of", label: "Father Of" },
    { value: "mother-of", label: "Mother Of" },
    { value: "husband-of", label: "Husband Of" },
    { value: "wife-of", label: "Wife Of" },
  ];

  const generateRandomCaptcha = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const captchaLength = 6;
    let newCaptcha = "";

    for (let i = 0; i < captchaLength; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      newCaptcha += characters.charAt(randomIndex);
    }

    return newCaptcha;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!inputValues.patient_name) {
      toast.error("Enter patient name");
      return;
    }
    // else if (!gender) {
    //   toast.error("Select Gender");
    //   return;
    // }
    else if (
      inputValues.email &&
      (!inputValues.email.includes(".") || !inputValues.email.includes("@"))
    ) {
      toast.error("Invalid email");
      return;
    } else if (!inputValues.contact_number) {
      toast.error("Enter your contact number");
      return;
    } else if (
      inputValues.contact_number.length > 14 ||
      inputValues.contact_number.length < 10
    ) {
      toast.error("Invalid Number");
      return;
    } else if (!inputValues.appointment_date) {
      toast.error("Enter date");
      return;
    } else if (!shift) {
      toast.error("Enter your shift");
      return;
    } else if (!input_captcha) {
      toast.error("Enter Captcha");
      return;
    } else if (captcha === input_captcha) {
      setCheckCaptcha("Captcha Verified");
    } else {
      setCheckCaptcha("Captcha failed");
    }
    if (captcha == input_captcha) {
      setLoading(true);
      setCheckCaptcha("Captcha Verified");

      try {
        const myallInputs = {
          ...inputValues,
          gender,
          shift,
          relation,
          doctor_id: sitedata.site_id,
          hospital_id: selectedHospital.value.info.uid,
        };

        const response = await SendPostRequest(
          "doctors/appointment_form",
          myallInputs
        );

        if (response.status === "success") {
          setInputValues({
            patient_name: patientLogin ? patientLogin.fullname : "",
            email: patientLogin ? patientLogin.email : "",
            contact_number: patientLogin ? patientLogin.contact_num : "",
            age: "",
            relation_name: "",
            appointment_date: "",
            remarks: "",
          });

          setDisplayedValue(null);
          handleRefresh();
          setRelation(null);
          setShift(null);
          setGender(null);
          setInputCaptcha("");
          setCheckCaptcha("");
        }
        setLoading(false);

        if (response.status === "success") {
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        setLoading(false);
        toast.error("Failed");
        console.log("error", error);
      }
    } else {
      setCheckCaptcha("Captcha failed");
    }
  };

  const [backgroundImage, setBackgroundImage] = useState("");
  useEffect(() => {
    let themeColor;
    if (sitedata) {
      themeColor = sitedata?.theme_color?.split(".css").join("");
    }

    setBackgroundImage(`/assets/img/doctors/banner_bg_${themeColor}.svg`);
  }, [sitedata?.theme_color]);

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Hospital/Clinic" Image="theme-2-banner-doctor.webp" />

        <div className="content-wrapper pad-none">
          <div className="content-inner">
            <section
              id="single-portfolio"
              className="single-portfolio pad-bottom-90 full-dark"
            >
              <div className="container">
                <div className="row relative">
                  <div className="col-lg-6 mb-3 mb-lg-0">
                    <div className="title-wrap">
                      <div className="section-title">
                        <h2 className="title text-uppercase mb-0">
                          {selectedHospital?.value?.info?.Name || "Doctor Detail"}
                        </h2>
                        <span className="custom-heading-title mb-0">
                          {selectedHospital?.value?.info?.Department}
                        </span>
                        <span className="section-border-bottom"></span>
                      </div>
                    </div>
                    <div className="row blog-list blog-list-style-1 br-style">
                      <div className="blog-inner">
                        <div className="media doctor_detail_img ">
                          <div className="row w-100">
                            <div className="col-lg-4 col-md-12 col-12">
                              <div
                                className="blog-thumb relative"
                                style={{ maxWidth: "100%" }}
                              >
                                {selectedHospital?.value?.info?.profile_pic ? (
                                  <img
                                    src={selectedHospital?.value?.info?.profile_pic}
                                    // src={`data:image/jpeg;base64,${selectedHospital?.value?.info?.profile_pic}`}
                                    className="img-fluid rounded m-0"
                                    width="170"
                                    height="130"
                                    alt="blog-img"
                                  />
                                ) : (
                                  <div
                                    className="shimmer"
                                    style={{
                                      width: "170px",
                                      height: "130px",
                                      borderRadius: "4px",
                                      backgroundColor: "#f0f0f0",
                                      animation: "shimmer 2s infinite linear",
                                      background:
                                        "linear-gradient(to right,rgb(212, 211, 211) 8%,rgb(196, 191, 191) 18%,rgb(201, 197, 197) 33%)",
                                      backgroundSize: "800px 104px",
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="col-lg-8 col-md-12 col-12">
                              <div>
                                {selectedHospital ? (
                                  <div className="row my-2">
                                    <div className="col-6 mb-2">
                                      <p className="mb-0 fw-bold">Fee</p>
                                      <span>
                                        {selectedHospital?.value?.info?.fee ||
                                          "--"}
                                      </span>
                                    </div>
                                    <div className="col-6 mb-2">
                                      <p className="mb-0 fw-bold">Email</p>
                                      <span>
                                        {selectedHospital?.value?.info?.email ||
                                          "--"}
                                      </span>
                                    </div>
                                    <div className="col-6 mb-2">
                                      <p className="mb-0 fw-bold">
                                        Contact Number
                                      </p>
                                      <span>
                                        {selectedHospital?.value?.info
                                          ?.contact_no || "--"}
                                      </span>
                                    </div>
                                    <div className="col-6 mb-2">
                                      <p className="mb-0 fw-bold">Address</p>
                                      <span>
                                        {selectedHospital?.value?.info
                                          ?.address || "--"}
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="row my-2">
                                    <div className="col-lg-6 mb-2">
                                      <div
                                        className="shimmer"
                                        style={{
                                          width: "60px",
                                          height: "16px",
                                          marginBottom: "4px",
                                          backgroundColor: "#f0f0f0",
                                        }}
                                      />
                                      <div
                                        className="shimmer"
                                        style={{
                                          width: "80px",
                                          height: "14px",
                                          backgroundColor: "#f0f0f0",
                                        }}
                                      />
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                      <div
                                        className="shimmer"
                                        style={{
                                          width: "60px",
                                          height: "16px",
                                          marginBottom: "4px",
                                          backgroundColor: "#f0f0f0",
                                        }}
                                      />
                                      <div
                                        className="shimmer"
                                        style={{
                                          width: "120px",
                                          height: "14px",
                                          backgroundColor: "#f0f0f0",
                                        }}
                                      />
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                      <div
                                        className="shimmer"
                                        style={{
                                          width: "100px",
                                          height: "16px",
                                          marginBottom: "4px",
                                          backgroundColor: "#f0f0f0",
                                        }}
                                      />
                                      <div
                                        className="shimmer"
                                        style={{
                                          width: "100px",
                                          height: "14px",
                                          backgroundColor: "#f0f0f0",
                                        }}
                                      />
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                      <div
                                        className="shimmer"
                                        style={{
                                          width: "60px",
                                          height: "16px",
                                          marginBottom: "4px",
                                          backgroundColor: "#f0f0f0",
                                        }}
                                      />
                                      <div
                                        className="shimmer"
                                        style={{
                                          width: "150px",
                                          height: "14px",
                                          backgroundColor: "#f0f0f0",
                                        }}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h4 className="title mb-0 mt-2">Appointment Schedule</h4>
                    {hospitalDetail?.length === 0 ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <img
                          style={{ width: "500px", textAlign: "center" }}
                          src="/assets/img/search.png"
                          alt="data"
                        />
                        <h2 className=" text-center mt-3">
                          Website Under Construction
                        </h2>
                      </div>
                    ) : (
                      <div className="">
                        {hospitalDetail?.length > 1 ? (
                          <label className="cs_input_label cs_heading_color">
                            Please Select Hospital
                            <span className="asterisk">*</span>
                          </label>
                        ) : null}

                        {hospitalDetail?.length > 1 ? (
                          <Select
                            value={selectedHospital}
                            options={hospitalDetail.map((hospital) => ({
                              label: hospital.info.title,
                              value: hospital,
                            }))}
                            onChange={handleHospitalChange}
                            placeholder="Select Hospital"
                            className="hospital-clinic-appointmentform_select"
                          />
                        ) : (
                          // if only 1 hospital, show it as static text
                          <div className="hospital-single-label">
                            {selectedHospital?.label}
                          </div>
                        )}

                        <div className="my-4"></div>
                        {/* <div className="appointment-schedule">
                          {selectedHospital && (
                            <Table striped bordered hover>
                              <thead>
                                <tr>
                                  <th>Day</th>
                                  <th>Morning</th>
                                  <th>Evening</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Object.keys(
                                  selectedHospital.value.schedule
                                ).map((day) => (
                                  <tr key={day}>
                                    <td>{day}</td>
                                    <td>
                                      {selectedHospital.value.schedule[day]
                                        ?.Morning ? (
                                        <span>
                                          <i className="fa-regular fa-clock"></i>{" "}
                                          {selectedHospital.value.schedule[day]
                                            .Morning.Start === "On Call" ||
                                            selectedHospital.value.schedule[day]
                                              .Morning.End === "On Call"
                                            ? "On Call"
                                            : `${formatTime(
                                              selectedHospital.value.schedule[
                                                day
                                              ].Morning.Start
                                            )} - ${formatTime(
                                              selectedHospital.value.schedule[
                                                day
                                              ].Morning.End
                                            )}`}
                                        </span>
                                      ) : (
                                        <span>
                                          <i className="fa-regular fa-clock mr-1"></i>{" "}
                                          N/A
                                        </span>
                                      )}
                                    </td>
                                    <td>
                                      {selectedHospital.value.schedule[day]
                                        ?.Evening ? (
                                        <span>
                                          <i className="fa-regular fa-clock"></i>{" "}
                                          {selectedHospital.value.schedule[day]
                                            .Evening.Start === "On Call" ||
                                            selectedHospital.value.schedule[day]
                                              .Evening.End === "On Call"
                                            ? "On Call"
                                            : `${formatTime(
                                              selectedHospital.value.schedule[
                                                day
                                              ].Evening.Start
                                            )} - ${formatTime(
                                              selectedHospital.value.schedule[
                                                day
                                              ].Evening.End
                                            )}`}
                                        </span>
                                      ) : (
                                        <span>
                                          <i className="fa-regular fa-clock mr-1"></i>{" "}
                                          N/A
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          )}
                        </div> */}

                        <div className="appointment-schedule">
                          {selectedHospital ? (
                            selectedHospital.value.schedule &&
                              Object.keys(selectedHospital.value.schedule).length > 0 ? (
                              <Table striped bordered hover>
                                <thead>
                                  <tr>
                                    <th>Day</th>
                                    <th>Morning</th>
                                    <th>Evening</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Object.keys(selectedHospital.value.schedule).map((day) => (
                                    <tr key={day}>
                                      <td>{day}</td>
                                      <td>
                                        {selectedHospital.value.schedule[day]?.Morning ? (
                                          <span>
                                            <i className="fa-regular fa-clock"></i>{" "}
                                            {selectedHospital.value.schedule[day].Morning.Start ===
                                              "On Call" ||
                                              selectedHospital.value.schedule[day].Morning.End ===
                                              "On Call"
                                              ? "On Call"
                                              : `${formatTime(
                                                selectedHospital.value.schedule[day].Morning.Start
                                              )} - ${formatTime(
                                                selectedHospital.value.schedule[day].Morning.End
                                              )}`}
                                          </span>
                                        ) : (
                                          <span>
                                            <i className="fa-regular fa-clock mr-1"></i> N/A
                                          </span>
                                        )}
                                      </td>
                                      <td>
                                        {selectedHospital.value.schedule[day]?.Evening ? (
                                          <span>
                                            <i className="fa-regular fa-clock"></i>{" "}
                                            {selectedHospital.value.schedule[day].Evening.Start ===
                                              "On Call" ||
                                              selectedHospital.value.schedule[day].Evening.End ===
                                              "On Call"
                                              ? "On Call"
                                              : `${formatTime(
                                                selectedHospital.value.schedule[day].Evening.Start
                                              )} - ${formatTime(
                                                selectedHospital.value.schedule[day].Evening.End
                                              )}`}
                                          </span>
                                        ) : (
                                          <span>
                                            <i className="fa-regular fa-clock mr-1"></i> N/A
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            ) : (
                              <div className="schedules_wrapper px-4">
                                <h4 className="title mb-2">Appointment Schedule</h4>
                                <p className="mb-3" style={{ fontSize: "16px", color: "#555" }}>
                                  Appointment schedule will be available soon. Please check back later.
                                </p>
                              </div>
                            )
                          ) : null}
                        </div>

                      </div>
                    )}
                  </div>

                  <div className="col-lg-6 mb-3 mb-lg-0">
                    <div className="title-wrap">
                      <div className="section-title">
                        <h2 className="title mb-0">Book An Appointment</h2>
                        <span className="section-border-bottom"></span>
                      </div>
                    </div>
                    <form className="row">
                      <div className="col-lg-6 mb-4">
                        <label className="cs_input_label cs_heading_color">
                          Patient Name <span className="asterisk">*</span>
                        </label>
                        <input
                          name="patient_name"
                          value={inputValues.patient_name}
                          type="text"
                          className="hospital_clinic_appointmentform_input"
                          placeholder="Enter Patient Name"
                          onChange={handleAllInputChange}
                        />
                        <div className="cs_height_42 cs_height_xl_25"></div>
                      </div>
                      {/* <div className="col-lg-6 mb-4">
                        <label className="cs_input_label cs_heading_color">
                          Please Select Gender{" "}
                          <span className="asterisk">*</span>
                        </label>
                        <Select
                          className="hospital-clinic-appointmentform_select"
                          value={genderOptions.find(opt => opt.value === gender)}
                          options={genderOptions}
                          onChange={handleGenderChange}
                          placeholder="Select Gender"
                        />

                        <div className="cs_height_42 cs_height_xl_25"></div>
                      </div> */}
                      {/* <div className="col-lg-6 mb-4">
                        <label className="cs_input_label cs_heading_color">
                          Please Select Relation
                        </label>
                        <Select
                          className="hospital-clinic-appointmentform_select"
                          value={reasonOptions.find(opt => opt.value === relation)}
                          options={reasonOptions}
                          onChange={handleReasonChange}
                          placeholder="Select Relation"
                        />

                        <div className="cs_height_42 cs_height_xl_25"></div>
                      </div>
                      <div className="col-lg-6 mb-4 ">
                        <label className="cs_input_label cs_heading_color">
                          Relation Name
                        </label>
                        <input
                          name="relation_name"
                          value={inputValues.relation_name}
                          type="text"
                          className="hospital_clinic_appointmentform_input"
                          placeholder="Enter Relation Name"
                          onChange={handleAllInputChange}
                        />
                        <div className="cs_height_42 cs_height_xl_25"></div>
                      </div> */}
                      <div className="col-lg-6 mb-4">
                        <label className="cs_input_label cs_heading_color">
                          Contact Number <span className="asterisk">*</span>
                        </label>
                        <input
                          name="contact_number"
                          value={inputValues.contact_number}
                          type="number"
                          className="hospital_clinic_appointmentform_input"
                          placeholder="Enter Contact Number"
                          onChange={handleContactNumber}
                          maxLength={14}
                          minLength={10}
                        />
                        <div className="cs_height_42 cs_height_xl_25"></div>
                      </div>

                      <div className="col-lg-6 mb-4">
                        <label className="cs_input_label cs_heading_color">
                          Email
                        </label>
                        <input
                          name="email"
                          type="email"
                          value={inputValues.email}
                          className="hospital_clinic_appointmentform_input"
                          placeholder="Enter Your Email"
                          onChange={handleAllInputChange}
                        />
                        <div className="cs_height_42 cs_height_xl_25"></div>
                      </div>


                      <div className="col-lg-6 mb-4">
                        <label className="cs_input_label cs_heading_color">
                          Appointment Date <span className="asterisk">*</span>
                        </label>
                        <div className="cs_with_icon_input">
                          <input
                            name="appointment_date"
                            type="date"
                            value={inputValues.appointment_date}
                            className="hospital_clinic_appointmentform_input"
                            id="datepicker"
                            maxLength={10}
                            placeholder="August 24, 2023"
                            onChange={handleAllInputChange}
                            min={todayDate}
                          />
                        </div>
                        <div className="cs_height_42 cs_height_xl_25"></div>
                      </div>

                      <div className="col-lg-6 mb-4 light-select-wrapper">
                        <label className="cs_input_label cs_heading_color">
                          Appointment Time <span className="asterisk">*</span>
                        </label>
                        <Select
                          className="hospital-clinic-appointmentform_select"
                          value={displayedValue !== null ? { value: shift, label: displayedValue } : null}
                          options={shiftOptions}
                          onChange={handleShiftChange}
                          placeholder={inputValues.appointment_date ? "Select Time" : "Please Select Date First"}
                        />

                        <div className="cs_height_42 cs_height_xl_25"></div>
                      </div>

                      {/* <div className="col-lg-6 mb-1">
                        <label className="cs_input_label cs_heading_color">
                          Age
                        </label>
                        <input
                          value={inputValues.age}
                          name="age"
                          type="number"
                          className="hospital_clinic_appointmentform_input"
                          placeholder="Enter Your Age"
                          onChange={handleAllInputChange}
                        />
                        <div className="cs_height_42 cs_height_xl_25"></div>
                      </div> */}

                      <div className="col-lg-6 mb-1 hospital_clinic_appointmentform_captcha">
                        <label className="cs_input_label cs_heading_color">
                          Captcha <span className="asterisk">*</span>
                        </label>
                        <Captcha
                          captcha={captcha}
                          inputCaptcha={input_captcha}
                          textColorClass={textColorClass}
                          checkCaptcha={check_captcha}
                          handleInputChange={handleInputChange}
                        />
                      </div>

                      <div className="col-lg-12 mb-4">
                        <label className="cs_input_label cs_heading_color">
                          Information / Note
                        </label>
                        <textarea
                          rows={2}
                          name="remarks"
                          value={inputValues.remarks}
                          className="appointmentform_input_textareea"
                          placeholder="Write Your Remarks Here........."
                          onChange={handleAllInputChange}
                        ></textarea>
                        <div className="cs_height_45 cs_height_xl_25"></div>
                      </div>

                      <div className="col-lg-12 theme_submit_btn_wrapper  mb-4">
                        <button
                          className="btn btn-default"
                          type="submit"
                          onClick={handleSubmit}
                          disabled={loading}
                        >
                          <span>
                            <span>{loading ? "Please wait" : "Submit"}</span>
                          </span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>

        <FooterWrapper />
      </div>
    </div>
  );
}

export default HospitalClinic;